import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SessionExpiredProvider, useSessionExpired } from './context/SessionExpiredContext';
import { registerSessionExpiredHandler } from './services/api';

import LoginPage from './Pages/Login/LoginPage.jsx';
import NotFoundPage from './Pages/NotFoundPage.jsx';
import AdminPanel from './Pages/AdminPanel.jsx';
import HomeDinamica from './Pages/Home/HomePage.jsx';
import Escala from './Pages/Escala';
import Reunioes from './Pages/Reunioes';
import Formacao from './Pages/Formacao';
import Instrucoes from './Pages/Instrucoes';
import Coordenar from './Pages/Coordenacao';
import TercoDiario from './Pages/TercoDiario';
import ForgotPasswordPage from './Pages/ForgotPasswordPage.jsx';
import ResetPasswordPage from './Pages/ResetPasswordPage.jsx';
import React, { useEffect } from 'react';

function AppContent() {
  const { showModal } = useSessionExpired();

  useEffect(() => {
    registerSessionExpiredHandler(showModal);
  }, [showModal]);

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/recuperar-senha" element={<ForgotPasswordPage />} />
      <Route path="/resetar-senha" element={<ResetPasswordPage />} />
      <Route
        path="/diocese/:dioceseSlug/paroquia/:paroquiaSlug/comunidade/:comunidadeSlug/tipo/:tipoSlug"
        element={<HomeDinamica />}
      />
      <Route
        path="/diocese/:dioceseSlug/paroquia/:paroquiaSlug/comunidade/:comunidadeSlug/tipo/:tipoSlug/escala"
        element={<Escala />}
      />
      <Route
        path="/diocese/:dioceseSlug/paroquia/:paroquiaSlug/comunidade/:comunidadeSlug/tipo/:tipoSlug/reunioes"
        element={<Reunioes />}
      />
      <Route
        path="/diocese/:dioceseSlug/paroquia/:paroquiaSlug/comunidade/:comunidadeSlug/tipo/:tipoSlug/formacao"
        element={<Formacao />}
      />
      <Route
        path="/diocese/:dioceseSlug/paroquia/:paroquiaSlug/comunidade/:comunidadeSlug/tipo/:tipoSlug/instrucoes"
        element={<Instrucoes />}
      />
      <Route
        path="/diocese/:dioceseSlug/paroquia/:paroquiaSlug/comunidade/:comunidadeSlug/tipo/:tipoSlug/terco-diario"
        element={<TercoDiario />}
      />
      <Route
        path="/diocese/:dioceseSlug/paroquia/:paroquiaSlug/comunidade/:comunidadeSlug/tipo/:tipoSlug/coordenacao"
        element={<Coordenar />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <SessionExpiredProvider>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </SessionExpiredProvider>
  );
}